<template>
  <div class="flex flex-wrap gap-2">
    <button
      v-for="color in colors"
      :key="color"
      :style="{ backgroundColor: color }"
      class="w-10 h-10 rounded-full border-2 ring-offset-2 transition-shadow"
      :class="modelValue === color ? 'ring-2 ring-primary' : 'border-base-300'"
      @click="emit('update:modelValue', color)" />
  </div>
</template>

<script setup lang="ts">
import type { PropType } from "vue";

// 1. Define props with types…
const props = withDefaults(
  defineProps<{
    modelValue: string;
    colors?: string[];
  }>(),
  {
    colors: () => [
      "#EF4444", // red-500
      "#F59E0B", // amber-500
      "#10B981", // emerald-500
      "#3B82F6", // blue-500
      "#8B5CF6", // violet-500
    ],
  }
);

const emit = defineEmits<{
  (e: "update:modelValue", value: string): void;
}>();
</script>
